const state = {
  token:'',
  userData:{
    name: '',
    surname: '',
    dni: '',
    birthday:'',
    street: '',
    postcode: '',
    city: '',
    state: '',
    country: 'España',
    email: '',
    confirmar: '',
    prefix: '',
    phone: '',
    //club:'independiente',
    observaciones: '',
    updatedPhone: 1,
  }
}

const getters = {
  getToken: (state) => state.token,
  getCustomer: (state) => state.userData
}

const mutations = {
  setToken (state, token) { state.token = token },
  setCustomer(state, customer) {
    for(const key of Object.keys(state.userData)){
      state.userData[key] = customer[key]
    }
  },
  clearCustomer(state) {
    state.token = ''
    state.userData.name =  ''
    state.userData.surname =  ''
    state.userData.dni =  ''
    state.userData.birthday = ''
    state.userData.street =  ''
    state.userData.postcode =  ''
    state.userData.city =  ''
    state.userData.state =  ''
    state.userData.country =  'España'
    state.userData.email =  ''
    state.userData.confirmar =  ''
    state.userData.prefix = ''
    state.userData.phone =  ''
   // state.userData.club = 'independiente'
    state.userData.observaciones =  '',
    state.userData.updatedPhone = 1;
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/_store/modules/user.js